import company_config from './company_config.json';

function getCompany() {
    for (let i = 0; i < company_config.length; i++) {
        const company = company_config[i];
        if (window.location.host == company.host) {
            return company;
        }
    }
    return company_config[0];
}

export default getCompany();
